import styled from 'styled-components';

const HeaderWrapper = styled.header`
  height: ${({ theme }) => theme.spacing(8)};
  padding-bottom: ${({ theme }) => theme.spacing(0.5)};
  border-bottom: 2px solid ${({ theme }) => theme.colors.neutral.gray[300]};
`;

// eslint-disable-next-line import/prefer-default-export
export { HeaderWrapper };
